function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesCac05Branco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g12-6",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g14",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g16",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g18",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g20",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g22",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g24",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g26",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g28",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g30",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g32",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g34",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g36",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g38",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g40",
    transform: "matrix(0.1171875,0,0,0.1171875,-274.50602,-227.51807)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    transform: "matrix(0.11723939,0,0,0.11723939,-0.0132655,-0.02651982)",
    id: "g86"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g18-5"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 266.72299,
    y1: 164.89,
    x2: 166.67,
    y2: 164.89,
    id: "line2"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 200.502,
    y1: 307.57001,
    x2: 336.87601,
    y2: 307.57001,
    id: "line4"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 74.833,
    y1: 322.00201,
    x2: 52.868,
    y2: 359.577,
    id: "line6"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 197.825,
    y1: 111.603,
    x2: 146.70599,
    y2: 199.05,
    id: "line8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "M 316.881,116.232 264.899,27.308 c -3.979,-6.807 -13.818,-6.807 -17.797,0 l -21.589,36.931",
    id: "path10-1"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 394.427,
    y1: 248.88699,
    x2: 364.026,
    y2: 196.881,
    id: "line12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 300.756,450.258 h 193.421 c 7.959,0 12.915,-8.638 8.899,-15.509 L 436.584,321.004",
    id: "path14-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "M 36.297,387.925 8.924,434.749 c -4.017,6.871 0.939,15.509 8.899,15.509 h 165.422",
    id: "path16-3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g44"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g28-8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g22-9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 394.967,350.505 c 11.397,-3.743 22.115,-10.133 31.178,-19.195 29.606,-29.605 30.827,-76.846 3.666,-107.908 -1.911,-2.186 -5.27,-2.314 -7.324,-0.261 L 317.976,327.653 c -2.053,2.053 -1.925,5.412 0.261,7.323 12.814,11.205 28.383,17.567 44.33,19.111",
    id: "path20-8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g26-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 334.011,311.618 c 20.004,20.004 52.437,20.004 72.441,0 20.004,-20.004 20.004,-52.437 0,-72.441 z",
    id: "path24-1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g32-5"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 370.23099,
    y1: 275.397,
    x2: 406.32599,
    y2: 311.492,
    id: "line30"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g42"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g36-3"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 370.23099,
    y1: 275.397,
    x2: 367.96301,
    y2: 326.392,
    id: "line34"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g40-2"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 370.23099,
    y1: 275.397,
    x2: 421.22601,
    y2: 273.129,
    id: "line38"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g50"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g48"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 229.203,80.131 c 0,17.362 -14.075,31.437 -31.437,31.437 -17.362,0 -31.437,-14.075 -31.437,-31.437 0,-13.07 17.815,-38.293 26.623,-49.965 2.412,-3.197 7.215,-3.197 9.627,0 8.809,11.673 26.624,36.895 26.624,49.965 z",
    id: "path46"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g58"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 353.994,126.676 c 4.295,-10.378 8.818,-21.299 12.081,-29.164 2.461,-5.931 7.962,-9.936 14.328,-10.768 4.656,-0.608 9.903,-2.673 13.058,-8.315 5.007,-8.955 1.427,-20.657 -7.785,-25.176 -6.047,-2.966 -12.819,-2.266 -17.972,1.111 -1.283,-6.025 -5.6,-11.29 -11.983,-13.44 -9.723,-3.275 -20.504,2.517 -23.252,12.402 -1.731,6.228 0.542,11.388 3.421,15.098 3.937,5.073 5.024,11.79 2.597,17.734 -3.204,7.846 -7.652,18.721 -11.889,29.071",
    id: "path52"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 277.706,225.783 c 4.149,4.597 9.189,8.268 15.047,10.679 25.768,10.606 57.431,-6.97 70.721,-39.259 13.29,-32.288 3.174,-67.061 -22.595,-77.667 -25.768,-10.606 -57.431,6.97 -70.721,39.259 -5.13,12.462 -6.758,25.29 -5.36,36.96",
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g76"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 183.888,250.21 c 3.256,-16.562 -5.969,-32.599 -21.126,-36.242 -4.606,-1.107 -9.242,-0.937 -13.598,0.279 0.011,-2.584 -0.27,-5.223 -0.875,-7.871 -3.907,-17.11 -19.751,-28.085 -35.39,-24.514 -15.639,3.571 -25.149,20.335 -21.243,37.445 0.605,2.648 1.497,5.148 2.628,7.471 -4.452,0.795 -8.703,2.654 -12.372,5.65 -12.074,9.861 -13.424,28.312 -3.302,41.819 -12.561,12.42 -13.04,33.648 -0.596,48.886 8.452,10.349 20.803,15.41 32.457,14.514 11.956,-0.919 23.319,4.522 29.784,14.091 2.664,3.943 7.435,5.895 12.074,4.835 l 0.876,-0.2 c 4.639,-1.059 8.09,-4.888 8.779,-9.597 1.671,-11.426 9.546,-21.261 20.716,-25.621 10.888,-4.251 19.819,-14.171 22.941,-27.163 4.599,-19.127 -5.046,-38.044 -21.753,-43.782 z",
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g74"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    x1: 125.092,
    y1: 235.25999,
    x2: 153.20599,
    y2: 356.37399,
    id: "line64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 134.324,275.698 c -0.148,-0.646 -1.938,-17.167 19.134,-26.995",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 134.324,275.698 c -0.148,-0.646 -5.705,-16.307 -28.955,-16.015",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "M 144.897,322.002 C 144.68,321.05 136.489,297.97 102.227,298.4",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 144.897,322.002 c -0.217,-0.952 -2.856,-25.299 28.198,-39.783",
    id: "path72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeOpacity: 1
    },
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    d: "m 182.73,406.844 c -9.699,35.641 9.36,71.859 42.569,80.896 33.209,9.037 67.992,-12.529 77.691,-48.17 9.699,-35.641 -6.315,-83.049 -39.523,-92.086 -33.208,-9.037 -71.038,23.719 -80.737,59.36 z",
    id: "path78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2626,-0.9649,0.9649,0.2626,-238.5127,550.1856)",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    },
    cx: 240.701,
    cy: 431.13901,
    rx: 31.841,
    ry: 29.559999,
    id: "ellipse80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesCac05Branco);
export default __webpack_public_path__ + "static/media/Icones_cac_05_branco.f893d37e0b96a7e56c92f0657c3057c5.svg";
export { ForwardRef as ReactComponent };